import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAngularEvent, IDirective, IRootScopeService, IScope} from "angular";

const css = require('./innlastingsindikator.scss');

export function innlastingsindikatorForInjisering() {
    return [innlastingsindikator];
}

export function innlastingsindikator(): IDirective {

    return {
        restrict: "E",
        replace: true,
        transclude: true,
        template: require('./innlastingsindikator.html'),
        scope: {},
        controller: InnlastingsindikatorKontroller.regNavn,
        controllerAs: 'ktr',
    };
}


export class InnlastingsindikatorKontroller {

    static regNavn = "InnlastingsindikatorKontroller";
    static vis_innlasting = "vis_innlasting";
    static innlasting_ferdig = "innlasting_ferdig";

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            InnlastingsindikatorKontroller
        ]
    }

    laster = false;

    constructor(private $scope: IScope) {
        this.$scope.$root.$on(InnlastingsindikatorKontroller.vis_innlasting, (event: IAngularEvent) => {
            event.stopPropagation();
            this.laster = true;
        });

        this.$scope.$root.$on(InnlastingsindikatorKontroller.innlasting_ferdig, (event: IAngularEvent) => {
            event.stopPropagation();
            this.laster = false;
        });
    }

    static visIndikator($rootScope: IRootScopeService) {
        $rootScope.$emit(InnlastingsindikatorKontroller.vis_innlasting);
    }

    static skjuleIndikator($rootScope: IRootScopeService) {
        $rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig);
    }
}
